const GTM_CAROUSEL = '-carousel';

const getGtmLink = (link) => {
    const ZERO = 0;
    let gtmLink = link.replace('/', '');
    const hashPos = gtmLink.indexOf('#');

    gtmLink = hashPos >= ZERO ? gtmLink.substring(ZERO, hashPos) : gtmLink;

    return gtmLink;
};

/**
 * Creates a data-spectate-product string value
 * @param {string} source source for GTM
 * @param {string} iconUrl url of the icon
 * @returns {string} An data-spectate-product value string
 */
export default function getGtm(source, iconUrl) {
    return `${source};${source}${GTM_CAROUSEL};${getGtmLink(iconUrl)}`;
}
